export enum TipoPagamento {
    BOLETO = 1,
    CARTAO = 2,
    PIX = 4
}